import { render, staticRenderFns } from "./AlertError.vue?vue&type=template&id=a98348e0&"
import script from "./AlertError.vue?vue&type=script&lang=js&"
export * from "./AlertError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports